import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Injectable } from '@angular/core';
import { combineLatest } from 'rxjs';
import { AuthService } from '../../../../core/services/auth.service';
import { CharterDAO } from '../../../../core/services/dao/charterDAO';
import { map, take } from 'rxjs/operators';
import { ApiHelper } from '../../../../core/services/apiHelper';
import { environment } from '../../../../environments/environment';

@Injectable()
export class ManageCharterResolve implements Resolve<any> {
  constructor(
    private authService: AuthService,
    private charterDao: CharterDAO,
    private apiHelper: ApiHelper,
  ) {
    this.apiHelper.setEnvironment(environment.envName);
  }

  resolve(route: ActivatedRouteSnapshot) {
    let sessionResolve = this.authService.checkSession();
    let charterResolve = this.charterDao.getByIdManageCharter(route.params.id);
    return combineLatest([sessionResolve, charterResolve]).pipe(
      map(([sessionResolve, charterResolve]) => ({
        sessionResolve,
        charterResolve,
      })),
      take(1),
    );
  }
}
